import { KeyboardKey } from './models/KeyboardKey';
export var KeysToKeyboardKeys = {
    Tab: KeyboardKey.Tab,
    Enter: KeyboardKey.Enter,
    Shift: KeyboardKey.Shift,
    Esc: KeyboardKey.Escape,
    Escape: KeyboardKey.Escape,
    Space: KeyboardKey.Space,
    // https://www.w3.org/TR/uievents-key/#keys-whitespace
    ' ': KeyboardKey.Space,
    Left: KeyboardKey.ArrowLeft,
    ArrowLeft: KeyboardKey.ArrowLeft,
    Up: KeyboardKey.ArrowUp,
    ArrowUp: KeyboardKey.ArrowUp,
    Right: KeyboardKey.ArrowRight,
    ArrowRight: KeyboardKey.ArrowRight,
    Down: KeyboardKey.ArrowDown,
    ArrowDown: KeyboardKey.ArrowDown,
    Zero: KeyboardKey.Zero,
    Nine: KeyboardKey.Nine,
    a: KeyboardKey.A,
    z: KeyboardKey.Z,
    A: KeyboardKey.A,
    Z: KeyboardKey.Z,
    ContextMenu: KeyboardKey.ContextMenu,
    '/': KeyboardKey.Slash,
    F10: KeyboardKey.F10,
    Home: KeyboardKey.Home,
    End: KeyboardKey.End,
    Delete: KeyboardKey.Delete,
    Backspace: KeyboardKey.Backspace,
};
export function getKey(event) {
    return KeysToKeyboardKeys[event.key] || KeyboardKey.Unknown;
}
//# sourceMappingURL=getKey.js.map